import { h } from 'preact';
import MinusIcon from 'utils/icon/icon-minus.svg';
import PlusIcon from 'utils/icon/icon-plus.svg';

const ProductQuantity = ({ quantity, changeQuantity, inventoryQuantity, isRemovable = false }) => {
  const setNewQty = (qty) => {
    if (qty && qty < 1) {
      changeQuantity(1);
      return;
    }

    changeQuantity(qty);
  };
  const onBlur = () => {
    if (isRemovable && !quantity) {
      setNewQty(0);
    }
    if (!isRemovable && !quantity) {
      setNewQty(1);
    }
  };

  return (
    <div
      className="flex h-40 w-[104px] items-center rounded-40 border border-gray-2 px-14 py-10 text-14 leading-100"
      onBlur={onBlur}
      tabIndex={-1}
    >
      <button
        type="button"
        aria-label={window.TMW.Strings.product.decreaseQuantity}
        className="flex w-16 items-center justify-center focus:ring-offset-0 disabled:text-gray-2"
        disabled={isRemovable ? false : quantity < 2}
        onClick={() => setNewQty(quantity - 1)}
      >
        <MinusIcon />
      </button>
      <input
        type="number"
        value={quantity}
        aria-label={window.TMW.Strings.product.quantityInput}
        className="flex h-36 w-40 items-center justify-center border-none p-0 text-center"
        onChange={(e) => setNewQty(e.target.value)}
        readOnly
      />
      <button
        type="button"
        aria-label={window.TMW.Strings.product.increaseQuantity}
        className="flex w-16 items-center justify-center focus:ring-offset-0 disabled:text-gray-2"
        disabled={quantity >= inventoryQuantity}
        onClick={() => setNewQty(quantity + 1)}
      >
        <PlusIcon />
      </button>
    </div>
  );
};

export default ProductQuantity;
